import { post, formPost } from "../../../js/http";
import storage from "good-storage";

$(".apply-nav li").click(function() {
  var index = $(this).index();
  $($(".apply-nav li")[index])
    .addClass("active")
    .siblings()
    .removeClass("active");
  $($(".apply-content .apply-content-item")[index])
    .addClass("active")
    .siblings()
    .removeClass("active");
});

$(".apply-con .usable-btn").click(function() {
  layui.use(["upload", "form", "layer"], function() {
    var $ = layui.jquery,
      upload = layui.upload,
      layer = layui.layer,
      form = layui.form;
    layer.open({
      type: 1,
      skin: "layer-custom",
      area: ["340px", ""],
      title: "",
      id: "applyCon",
      closeBtn: 2,
      content: $("#closeWinking-con")
    });
    // 特长选项
    $("#specialtyList span").on("click", function() {
      var index = $(this).index();
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
      } else {
        // 最多选三项
        if ($(".labelList-con span.active").length < 3) {
          $(this).addClass("active");
        }
      }
    });

    //获取省份
    getProvince();

    form.on("select(applyprovince)", function(data) {
      getCity({ ProvinceID: data.value });
    });

    function getProvince() {
      post("/ApiHome/ApiAction?_ControlName=GetCountryProvinceByPc").then(
        res => {
          if (res.ReturnStatus) {
            let provinceStr = "";
            res.Data.OnlyOneData.forEach((item, index) => {
              provinceStr +=
                "<option value=" +
                item.AutoID +
                ">" +
                item.ProvinceShortName +
                "</option>";
            });
            $("form select[name='applyprovince']").html(provinceStr);
            // 如果有省份
            if (storage.get("userInfo").AtProvinces) {
              $("form select[name='applyprovince']").val(
                storage.get("userInfo").AtProvinces
              );
            }
            form.render("select");
            // 如果有城市
            if (storage.get("userInfo").AtCities) {
              getCity({ ProvinceID: storage.get("userInfo").AtProvinces });
            }
          }
        }
      );
    }
    function getCity(data) {
      post("/ApiHome/ApiAction?_ControlName=GetCountryCityByPc", data).then(
        res => {
          if (res.ReturnStatus) {
            let cityStr = "";
            res.Data.OnlyOneData.forEach((item, index) => {
              cityStr +=
                "<option value=" +
                item.AutoID +
                ">" +
                item.CountryShortName +
                "</option>";
            });
            $("form select[name='applycity']").html(cityStr);
            if (storage.get("userInfo").AtCities) {
              $("form select[name='applycity']").val(
                storage.get("userInfo").AtCities
              );
            }
            form.render("select");
          }
        }
      );
    }

    var choose_frontfile_flag = false,
      choose_backfile_flag = false;
    upload.render({
      elem: "#idfront",
      url: "",
      auto: false,
      method: "post",
      // bindAction: "#sub-btn",
      field: "image",
      acceptMime: ".jpg, .png",
      size: 1024 * 6,
      choose: function(obj) {
        //预读本地文件示例，不支持ie8
        obj.preview(function(index, file, result) {
          //result  图片链接（base64）
          // $("#idfront").text("");
          $("#idfront i").remove();
          $("#idfront p").remove();
          $("#idfront").append('<span class="reupload">重新上传<span>');
          $("#idfront").css({
            "background-image": "url(" + result + ")",
            "background-size": "cover",
            "background-position": "center center"
          });
          if (file.name.length > 0) {
            choose_frontfile_flag = true;
          }
        });
      },
      done: function(res) {
        console.log(res);
      },
      error: function() {
        console.log(res);
      }
    });
    upload.render({
      elem: "#idback",
      url: "",
      auto: false,
      method: "post",
      // bindAction: "#sub-btn",
      field: "image",
      acceptMime: ".jpg, .png",
      size: 1024 * 6,
      choose: function(obj) {
        //预读本地文件示例，不支持ie8
        obj.preview(function(index, file, result) {
          //result  图片链接（base64
          $("#idback i").remove();
          $("#idback p").remove();
          $("#idback").append('<span class="reupload">重新上传<span>');
          // $("#idback").text("");
          $("#idback").css({
            "background-image": "url(" + result + ")",
            "background-size": "cover",
            "background-position": "center center"
          });
          if (file.name.length > 0) {
            choose_backfile_flag = true;
          }
        });
      },
      done: function(res) {
        console.log(res);
      },
      error: function() {
        console.log(res);
      }
    });
    $("#sub-btn").off("click");
    $("#sub-btn").click(function() {
      let activespanList = $("#specialtyList span.active"),
        specialtyStr = "";
      for (let i = 0; i < activespanList.length; i++) {
        specialtyStr += $(activespanList[i]).attr("data-id") + ",";
      }
      specialtyStr = specialtyStr.substring(0, specialtyStr.length - 1);
      if (specialtyStr == "") {
        layer.msg("请选择特长", function() {});
        return false;
      }
      if (choose_frontfile_flag == false) {
        layer.msg("请选择身份证正面照", function() {});
        return false;
      }

      if (choose_backfile_flag == false) {
        layer.msg("请选择手持身份证素颜照", function() {});
        return false;
      }

      let formData = new FormData();
      formData.append("UserID", storage.get("userInfo").UserID);
      formData.append("RealName", $("#applyRealName").val());
      formData.append("CardId", $("#applyRealCode").val());
      formData.append("ProvinceId", $("select[name='applyprovince']").val());
      formData.append("CityId", $("select[name='applycity']").val());
      formData.append("Reason", $("#applyReason").val());
      formData.append("Specialty", specialtyStr);
      formData.append(
        "frontcard",
        $("#idfront")
          .parent()
          .find('input[type="file"]')[0].files[0]
      );
      formData.append(
        "handlecard",
        $("#idback")
          .parent()
          .find('input[type="file"]')[0].files[0]
      );
      formPost(
        "/ApiHome/ApiAction?_ControlName=UploadApplyAngelInfoByPC",
        formData
      ).then(res => {
        if (res.ReturnStatus) {
          layer.msg(res.MessageCN, { icon: 1 });
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          layer.msg(res.MessageCN, { icon: 2 });
        }
      });
    });
  });
});

$("#angelRule").click(function() {
  post("/ApiHome/ApiAction?_ControlName=GetGoPageRuleByPC", {
    PackName: "CallMe.PC",
    RuleKey: "AngelManagementRule"
  }).then(res => {
    if (res.ReturnStatus) {
      window.open(res.Data.Url, "_blank");
    }
  });
});
